<template>
  <VirtualList
    :id="domId"
    :data-key="dataKey"
    :data-sources="data"
    :data-component="wrapCell"
    :wrap-class="wrapClass"
    :keeps="keeps"
    :extra-props="isHorizontal ? extraPropCumstom : extraProps"
    :wrap-style="wrapStyle"
    :style="{overflowY: 'auto', height: Number.isInteger(wrapHeight) ? wrapHeight + 'px' : '100%', width: '100%'}"
  />
</template>
<script>
import VirtualList from "vue-virtual-scroll-list";
import horizontal_cell from "./horizontal_cell.vue";
export default {
  components: { VirtualList },
  inject: {
    domId: { default: 'virtuallist-card'},
  },
  props: {
    extraProps: {
      type: Object,
      default: () => {},
    },
    dataKey: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    cell: {
      type: Object,
      default: () => {},
    },
    keeps: {
      type: Number,
      default: 8,
    },
    isHorizontal: {
      type: Boolean,
      default: false, //是否类似卡片横向布局
    },
    direction: {
      type: String,
      default: "vertical",
    },
    wrapClass: {
      type: String,
      default: "",
    },
    wrapStyle: {
      type: Object,
      default: () => {
        return { flexDirection: "column", display: "flex" };
      },
    },
    wrapWidth: {
      type: Number,
      default: 150, //卡片宽度
    },
    wrapHeight: {
      type: Number,
      default: null, //卡片宽度
    },
    containerWithType: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      wrapCell: this.isHorizontal ? horizontal_cell : this.cell,
      extraPropCumstom: {
        ...this.extraProps,
        component: this.cell,
        dataKey: this.dataKey,
      },
      number: 1, //横向几个
      data: [],
    };
  },
  watch: {
    list: {
      handler(val) {
        if (this.isHorizontal) {
          this.handle_list();
        } else {
          this.data = val;
        }
      },
      deep: true,
    },
    extraProps: {
      handler(val) {
        console.log('...index',val)
        if (this.isHorizontal) {
          this.extraPropCumstom = {
            ...val,
            component: this.cell,
            dataKey: this.dataKey,
          };
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.handle_list();
    window.addEventListener("resize", this.handle_list);
  },
  destroyed() {
    window.removeEventListener("resize", this.handle_list);
  },
  methods: {
    //分割数组
    get_horizontal_list() {
      let new_array = [];
      if (this.number == 0) return;
      let max = Math.ceil(this.list.length / this.number);
      for (let i = 0; i < max; i++) {
        let data = this.list.slice(
          i * this.number,
          i * this.number + this.number
        );
        new_array.push({
          data,
          [this.dataKey]: i,
        });
      }
      
      this.data = new_array;
    },
    //获取一行几个展示
    get_horizontal_number() {
      if (!this.isHorizontal) return;
      const dom = document.getElementById(this.domId);
      let width = this.containerWithType === 2 ? dom.offsetWidth : dom.scrollWidth;
      this.number = Math.floor(width / this.wrapWidth);
      
      // let max = Math.ceil(this.list.length / this.number);
    },
    handle_list() {
      this.get_horizontal_number();
      this.get_horizontal_list();
    },
  },
};
</script>
<style lang="scss" scoped></style>
